 export class BusModel {
        busID: number;

        busNumber: number;

        busType: string;

        eetRegNumber: number;

        regPlate: string;

        active = true;

        crewMembers = [];

        tempCrewMembers = [];

        oneDayAccesses = [];

        allPrimaryBusDrivers = [];
    }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/bus-list/bus.model.ts